(function() {
    'use strict';

    angular
        .module('claimsApp')
        .factory('ClaimAdjustInfo', ClaimAdjustInfo);

    ClaimAdjustInfo.$inject = ['$resource'];

    function ClaimAdjustInfo ($resource) {
        var resourceUrl =  GLOBAL_URL+'api/ga/claims/adjust-info';
        return $resource(resourceUrl, {}, {
            'searchClaimNum': {url:resourceUrl+'/search-claim-num', method: 'GET'},
            'loadAdjustInfo' :{url:resourceUrl+'/load-claim-adjust-info',method: 'GET'},
            'loadAdjustInfoHistory' :{url:resourceUrl+'/load-claim-adjust-info-history',method: 'GET'},
            'getReasonCancel':{url: resourceUrl+'/get-reason-cancel',isArray: true,method: 'GET'},
            'cancelCase':{url: resourceUrl+'/cancel-claim-adjust-info',method: 'POST'},
            'searchPolicyNum': {url:GLOBAL_URL+'api/ga/claim-search/search-policy-num', method: 'GET',isArray:true}
            });
    }
})();